import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_C, LL_VH_C, ModuleFE_RoutingV2, } from '@nu-art/thunderstorm-frontend/index';
import { QuaiAdvisorPageLoader } from '../../V4/index.js';
import { ModuleFE_Session } from '@nu-art/user-account-frontend';
import { ModuleFE_EMInterface } from '../../../_entity/runtime/em-interface/ModuleFE_EMInterface.js';
import { ModuleFE_AdvisorState } from '../../../modules/advisor-state/ModuleFE_AdvisorState.js';
import { ModuleFE_AdvisorSession, SessionKey_EHRInstanceId } from '../../../_entity/advisor-session/ModuleFE_AdvisorSession.js';
import { Second } from '@nu-art/ts-common';
export class Page_Bootstrap extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.triggered ??= false;
        return state;
    }
    componentDidMount() {
        if (!ModuleFE_Session.hasSession())
            return this.setState({ err: new Error('Did not receive JWT - Started up without a session') });
        this.setState({ triggered: true }, () => this.launchBootstrap());
    }
    //######################### Logic #########################
    launchBootstrap = async () => {
        //Get physician route
        const route = ModuleFE_RoutingV2.getRouteByKey('physician');
        if (!route)
            return this.setState({ err: new Error('Could not find physician route') });
        try {
            //Get bootstrap response
            const response = await ModuleFE_EMInterface.vv1.launch.bootstrap({}).executeSync();
            ModuleFE_AdvisorState.setProperties(response.uiState);
            ModuleFE_AdvisorSession.setArtifactMetadata(response.artifactMetadata);
            ModuleFE_AdvisorSession.lastSeenAt = response.lastSeenAt;
            ModuleFE_AdvisorSession.hasRecapItems = !!response.hasRecapItems;
            //Move to physician page
            const ehrInstanceId = SessionKey_EHRInstanceId.get();
            setTimeout(() => ModuleFE_RoutingV2.goToRoute(route, { 'ehr-id': ehrInstanceId }), Second);
        }
        catch (err) {
            this.logError(err);
            this.setState({ err: err });
        }
    };
    //######################### Render #########################
    render() {
        if (this.state?.err)
            return _jsx(LL_VH_C, { children: _jsxs(LL_V_C, { children: [_jsx("div", { children: "Error while bootstrap launching" }), _jsx("div", { children: this.state.err.message })] }) });
        return _jsx(QuaiAdvisorPageLoader, { text: 'Launching Bootstrap' });
    }
}
//# sourceMappingURL=Page_Bootstrap.js.map